import http from './httpService';
import { apiMETIS } from '../config.json';

export function getUserProjects() {
	return http.get(apiMETIS);
}

export function putUserProjects(data) {
	return http.put(apiMETIS, data);
}
